// extracted by mini-css-extract-plugin
export default {"input":"AddLinkForm_input__RIrY6"};